import api from "./api";

export const submitHelp = (data) => {
  return api.post("/questions", data);
};

export const submitFeedback = (data) => {
  return api.post("/questions", data);
};

export const submitChangePassword = (data) => {
  return api.post("/auth/update_password", data);
};

export const submitResetPassword = (data) => {
  return api.post("/auth/reset_password", data);
};

export const getCoord = (data) => {
  return api.get("/clinics/geocode?address=" + data);
};

export const submitBankDetails = ({ data, slug }) => {
  return api.post("/users/" + slug + "/bank", data);
};

export const updateBankDetails = ({ data, slug }) => {
  return api.put("/users/" + slug + "/bank", data);
};

export const getAllBanks = () => {
  return api.get("/banks");
};

export const getBankDetails = (slug) => {
  return api.get("/users/" + slug + "/bank");
};

export const getCountries = () => {
  return api.get("/countries");
};

export const getFacilityTypes = (country) => {
  return api.get(`/facility-types?country=${country}`);
};

export const getAllFacilityTypes = (country) => {
  return api.get(`/facility-types/all?country=${country}`);
};

export const getFacilityTypeById = (id, country) => {
  return api.get(`/facility-types/${id}?country=${country}`);
};

// New CSV-based Facility API Services
export const getFacTypes = (country) => {
  return api.get(`/fac-types?country=${country}`);
};

export const getFacList = (country, page = 1, perPage = 50) => {
  return api.get(`/fac-list?country=${country}&page=${page}&per_page=${perPage}`);
};

export const getFacListByType = (typeId, country) => {
  return api.get(`/fac-list/${typeId}?country=${country}`);
};

export const searchFacilities = (country, query) => {
  return api.get(`/fac-list/search?country=${country}&query=${query}`);
};

// Keep old services for backward compatibility
export const getFacilityTypesLegacy = getFacilityTypes;
export const getAllFacilityTypesLegacy = getAllFacilityTypes;

// Profession API Services
export const getProfessionTypes = () => {
  return api.get("/profession-types");
};

export const getProfessions = (country) => {
  if (country) {
    return api.get(`/countries/${country}/professions`);
  }
  return api.get("/professions");
};

export const getProfessionById = (id) => {
  return api.get(`/professions/${id}`);
};

export const getProfessionsByType = (country, type) => {
  const baseUrl = country ? `/countries/${country}/professions` : "/professions";
  return api.get(`${baseUrl}?type=${type}`);
};

export const updateUserProfession = (professionId) => {
  return api.post("/profile/profession", { profession_id: professionId });
};

export const getUserProfession = () => {
  return api.get("/profile/profession");
};

// Get specializations for a profession type (used in job posting)
export const getSpecializations = (professionType) => {
  // Uses profession-types endpoint with filter if needed
  // Falls back gracefully in the component if this returns empty
  return api.get(`/profession-types?parent=${professionType}`);
};
